// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__UZbXL","colMin":"styles_colMin__BHSrc","colCheckbox":"styles_colCheckbox__KWfzu"};